import { useContactManagementTranslation } from '../../../ui/hooks/useContactManagementTranslation';
import { Wizard } from '@juvare/common-form-ui/Wizard';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { ButtonBase, Paper, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
/*
 *  @deprecated New FullScreenWizard component has been added to Common-Form-UI.
 * */
export const FullPageWizard = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const downMdScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
    return (React.createElement(LayoutRows2, { row1: React.createElement(ButtonBase, { "data-test": 'navigation-back-button', sx: {
                p: 1,
                color: (theme) => theme.palette.text.secondary,
            }, onClick: props.onBack, "aria-label": t('common.back') },
            React.createElement(ArrowBack, { sx: { mr: 2 } }),
            React.createElement(Typography, { variant: 'body1' }, (_a = props.backButtonTitle) !== null && _a !== void 0 ? _a : t('common.back'))), row2: React.createElement(Paper, { elevation: 4, sx: [
                (theme) => ({
                    width: 900,
                    height: `calc(100% - ${theme.spacing(4)})`,
                    m: 'auto',
                    mt: 2,
                    mb: 2,
                }),
                downMdScreen ? { width: '100%', height: '100%', m: 0, pt: 2, borderRadius: 0, boxShadow: 'none' } : {},
            ] },
            React.createElement(Wizard, Object.assign({}, props))), fullHeightRow: 'row2', row2Scrollable: true }));
};
